import React, { useEffect, useState } from "react";
import { api, apiErr } from "../../lib/api";
import { toast } from "sonner";
import { Download, Receipt } from "lucide-react";

const eur = (n) => (n == null ? "—" : new Intl.NumberFormat("fr-FR", { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(n) + " €");
const fmt = (d) => { if (!d) return "—"; try { return new Date(d).toLocaleDateString("fr-FR"); } catch { return d; } };

export default function InvoicesTab() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(null);

  const load = () => {
    setLoading(true);
    api.get("/admin/invoices").then((r) => setRows(r.data)).catch((e) => toast.error(apiErr(e))).finally(() => setLoading(false));
  };
  useEffect(load, []);

  const download = async (b) => {
    setBusy(b.id);
    try {
      const r = await api.get(`/bookings/${b.id}/facture.pdf`, { responseType: "blob" });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement("a");
      a.href = url; a.download = `${b.invoice_number || "facture"}-${(b.nom || "").replace(/\s+/g, "-")}.pdf`;
      document.body.appendChild(a); a.click(); a.remove();
      URL.revokeObjectURL(url);
      if (!b.invoice_number) setTimeout(load, 800); // number assigned on first download
    } catch (e) { toast.error(apiErr(e)); } finally { setBusy(null); }
  };

  return (
    <div data-testid="invoices-tab">
      <div className="flex items-center gap-2 mb-4">
        <Receipt size={20} className="text-brand" strokeWidth={1.5} />
        <h2 className="font-heading text-xl text-ink-900">Journal des factures</h2>
      </div>
      <p className="text-sm text-ink-400 mb-5">Toutes les réservations dont l'acompte a été réglé. Le numéro de facture (FAC-AAAA-NNNN) est attribué au premier téléchargement, de façon séquentielle.</p>

      {loading ? <p className="text-ink-400">Chargement…</p> : rows.length === 0 ? (
        <p className="text-ink-400">Aucune facture pour le moment.</p>
      ) : (
        <div className="bg-white rounded-2xl border border-black/5 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="text-left text-xs text-ink-400 border-b border-black/5">
                  <th className="px-4 py-3">N° facture</th>
                  <th className="px-4 py-3">Client</th>
                  <th className="px-4 py-3">Hébergement</th>
                  <th className="px-4 py-3">Séjour</th>
                  <th className="px-4 py-3 text-right">Total</th>
                  <th className="px-4 py-3 text-right">Acompte</th>
                  <th className="px-4 py-3 text-right">PDF</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((b) => (
                  <tr key={b.id} className="border-b border-black/5 last:border-0 hover:bg-cream/40" data-testid={`invoice-row-${b.id}`}>
                    <td className="px-4 py-3 font-medium text-ink-900">{b.invoice_number || <span className="text-ink-400 italic">non émise</span>}</td>
                    <td className="px-4 py-3">{b.nom}</td>
                    <td className="px-4 py-3 text-ink-600">{b.accommodation_name}</td>
                    <td className="px-4 py-3 text-ink-600">{fmt(b.arrivee)} → {fmt(b.depart)}</td>
                    <td className="px-4 py-3 text-right tabular-nums">{eur(b.total)}</td>
                    <td className="px-4 py-3 text-right tabular-nums">{eur(b.paid_amount)}</td>
                    <td className="px-4 py-3 text-right">
                      <button onClick={() => download(b)} disabled={busy === b.id} className="inline-flex items-center gap-1.5 rounded-full bg-brand text-white px-3 py-1.5 text-xs font-medium hover:bg-brand-600 disabled:opacity-50" data-testid={`invoice-dl-${b.id}`}>
                        <Download size={13} /> {busy === b.id ? "…" : "Télécharger"}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
